import W3C_html from "./../../assets/images/W3C_html.png";
import W3C_css from "./../../assets/images/W3C_css.png";
import { base_url, base_url_completa } from "../../constants";

export default function Footer(){
    //console.log(base_url_completa);
    
    return(        
    <footer className="page-footer text-center font-small">
        <div className="container-fluid">
            <div className="row">
                <div className=" col-md-4">
                    <a className="html5 iconos_accesibilidad mr-2 d-inline" href={`https://validator.w3.org/nu/?doc=${base_url_completa}`} target="_blank" aria-label="Sello Accesibilidad" rel="noopener noreferrer">
                        <img className="img-fluid mt-4" src={W3C_html} alt="Validation HTML5"/>
                    </a>
                    <a className="css iconos_accesibilidad " href={`http://jigsaw.w3.org/css-validator/validator?uri=${base_url_completa}%2F&amp;profile=css3svg&amp;usermedium=all&amp;warning=1&amp;vextwarning=&amp;lang=es`} target="_blank" rel="noopener noreferrer" aria-label="Sello Accesibilidad">
                        <img className="img-fluid mt-4" src={W3C_css} alt="Validation CSS"/>
                    </a>
                </div>
                <div className=" col-md-4">
                    <div className="py-4 font-weight-bold">
                        <p>Tribunal Electoral del Poder Judicial de la Federación (TEPJF)</p>
                        <p>Teléfonos 55-5728-2300 y 55-5484-5410.</p>
                        <p>Todos los derechos reservados.</p>
                    </div>
                    <div className=" py-3">
                        <p><a href="https://www.te.gob.mx/transparencia/front/buscador/datos_personales#aviso" target="_blank" rel="noopener noreferrer">Avisos de privacidad</a></p>
                        <p>Para su correcta visualización, se recomienda utilizar</p>
                        <p>
                            <a href="https://www.google.com.mx/chrome/browser/desktop/" target="_blank" rel="noopener noreferrer">Google Chrome</a>
                            o
                            <a href="https://www.mozilla.org/es-MX/firefox/new/" target="_blank" rel="noopener noreferrer">Firefox</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>    
    </footer>
    );
}